<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.3335 2.00024L14.6668 2.00024" stroke="black" stroke-linecap="round"/>
<path d="M1.3335 13.9998L14.6668 13.9998" stroke="black" stroke-linecap="round"/>
<rect x="11.667" y="5.99976" width="4" height="7.33331" rx="1" transform="rotate(90 11.667 5.99976)" fill="black"/>
</svg>
